import React from 'react'

// WRDS-771: Google Play account-deletion requirement — a public web page
// where users can request deletion WITHOUT the app, referenced in the Play
// Console Data-deletion section. Must name the app + developer entity.
function DeleteAccount() {
  return (
    <div className='privacy-policy-pages py-5'>
      <div className='container'>
        <div className='page-header'>
          <h1>Delete Your WiL Reji Account</h1>
        </div>
        <div className='cms-wraper'>
          <p>
            This page lets you delete your account and associated data for the <strong>WiL Reji</strong> POS service
            (including the <strong>WiL Reji Waiter</strong> and <strong>WiL Reji Cashier</strong> apps), provided by{' '}
            <strong>WiLLDesign Inc.</strong>
          </p>

          <h2>Option 1 — Delete from the WiL Reji web dashboard</h2>
          <p>
            Restaurant owners: sign in to the WiL Reji web dashboard, open the <strong>Profile</strong> page, and select{' '}
            <strong>Delete Account</strong>. After confirmation, your account and associated personal data are deleted
            and your session ends immediately.
          </p>
          <br></br>

          <h2>Option 2 — Request deletion by email</h2>
          <p>
            Email <a href='mailto:contact@willdesign-tech.com?subject=WiL%20Reji%20account%20deletion%20request'>contact@willdesign-tech.com</a>{' '}
            from the email address registered to your account with the subject &quot;WiL Reji account deletion
            request&quot;. We will verify your identity and complete the deletion without undue delay.
          </p>
          <br></br>

          <h2>What is deleted, what is kept</h2>
          <ul className='list-li-dot'>
            <li>
              Deleted: your account information (name, email, phone), store configuration, and usage data — removed
              within 30 days of the request.
            </li>
            <li>
              Kept where the law requires it: sales and transaction records are retained for up to 7 years to meet
              Japanese bookkeeping and tax requirements, then deleted.
            </li>
          </ul>
          <p>
            Details: see the <a href='/privacy-policy'>WiL Reji Privacy Policy</a>.
          </p>
        </div>
      </div>
    </div>
  )
}

export default DeleteAccount
